const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 211 211",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M146.101,163.942l-81.983,0c-5.421,0 -10.35,-2.521 -13.521,-6.921c-3.171,-4.4 -4.004,-9.875 -2.287,-15.017l2.933,-8.804c3.038,-9.104 11.158,-15.742 20.692,-16.913c8.721,-1.067 21.554,-2.346 33.175,-2.346c11.617,0 24.454,1.279 33.179,2.346c9.529,1.167 17.65,7.808 20.688,16.913l2.933,8.804c1.717,5.142 0.883,10.617 -2.292,15.017c-3.171,4.4 -8.096,6.921 -13.517,6.921Zm-40.992,-41.667c-11.2,0 -23.671,1.242 -32.158,2.288c-6.362,0.779 -11.779,5.204 -13.8,11.275l-2.933,8.8c-0.858,2.575 -0.442,5.308 1.142,7.508c1.583,2.2 4.046,3.463 6.758,3.463l81.983,0c2.708,0 5.175,-1.263 6.758,-3.458c1.587,-2.2 2,-4.938 1.146,-7.512l-2.933,-8.8c-2.025,-6.071 -7.442,-10.5 -13.8,-11.275c-8.492,-1.046 -20.967,-2.288 -32.162,-2.288Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.11,109.776c-19.529,0 -35.417,-15.887 -35.417,-35.417c0,-19.529 15.887,-35.417 35.417,-35.417c19.529,0 35.417,15.888 35.417,35.417c0,19.529 -15.887,35.417 -35.417,35.417Zm0,-62.5c-14.933,0 -27.083,12.15 -27.083,27.083c0,14.933 12.15,27.083 27.083,27.083c14.933,0 27.083,-12.15 27.083,-27.083c0,-14.933 -12.15,-27.083 -27.083,-27.083Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.61,78.692c-2.263,0 -4.117,-1.812 -4.167,-4.083c-0.112,-5.562 1.95,-10.837 5.808,-14.85c3.854,-4.013 9.042,-6.283 14.604,-6.396c2.342,0.042 4.204,1.783 4.25,4.083c0.046,2.3 -1.783,4.204 -4.083,4.25c-3.337,0.067 -6.45,1.429 -8.762,3.833c-2.312,2.408 -3.55,5.571 -3.483,8.912c0.046,2.3 -1.783,4.204 -4.083,4.25l-0.083,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.11,
    cy: 105.11,
    r: 100.943,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "8.33px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.8c44cdcd1470d920af23e7d1a5067ea1.svg";
export { ForwardRef as ReactComponent };